import { createAsyncThunk } from '@reduxjs/toolkit';
import gamesModel from 'store/models/games';
import {
  TAppState,
  TPlayerRating,
  TRatingResponse,
  TRPSGameConfig,
} from '../types/gamesSchema';

//GET
export const fetchState = createAsyncThunk(
  'games/fetchState',
  async (_, { rejectWithValue }) => {
    try {
      const response: {
        data: {
          data: TAppState;
        };
      } = await gamesModel.getState();
      // console.log(response);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchGameState = createAsyncThunk(
  'games/fetchGameState',
  async (gameId: string, { rejectWithValue }) => {
    try {
      const response: {
        data: {
          data: TRPSGameConfig;
        };
      } = await gamesModel.getGameState(gameId);
      // console.log(response);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchGameRating = createAsyncThunk(
  'games/fetchGameRating',
  async (_, { rejectWithValue }) => {
    try {
      const response: {
        data: {
          data: TRatingResponse;
        };
      } = await gamesModel.getGameRating();
      // console.log(response);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchGameFriends = createAsyncThunk(
  'games/fetchGameFriends',
  async (_, { rejectWithValue }) => {
    try {
      const response: {
        data: {
          data: TPlayerRating[];
        };
      } = await gamesModel.getGameFriends();
      // console.log(response);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchPlayGame = createAsyncThunk(
  'games/fetchPlayGame',
  async (gameName: string, { rejectWithValue }) => {
    try {
      const response: { data: { data: TRPSGameConfig } } =
        await gamesModel.postPlayGame(gameName);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchLeaveGame = createAsyncThunk(
  'games/fetchLeaveGame',
  async (data: { gameId: string; tgId: number }, { rejectWithValue }) => {
    try {
      const response = await gamesModel.postLeaveGame(data.gameId);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchMoveGame = createAsyncThunk(
  'games/fetchMoveGame',
  async (data: { game_id: string; action: string }, { rejectWithValue }) => {
    try {
      const response: { data: { data: TRPSGameConfig } } =
        await gamesModel.postMoveGame(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchJoinNextRoundGame = createAsyncThunk(
  'games/fetchJoinNextRoundGame',
  async (data: { game_id: string }, { rejectWithValue }) => {
    try {
      const response: { data: { data: TRPSGameConfig } } =
        await gamesModel.postJoinNextRoundGame(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchCompleteNoMove = createAsyncThunk(
  'games/fetchCompleteNoMove',
  async (data: { game_id: string }, { rejectWithValue }) => {
    try {
      const response: { data: { data: TRPSGameConfig }; status: number } =
        await gamesModel.postCompleteNoMove(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchContinueAwaiting = createAsyncThunk(
  'games/fetchContinueAwaiting',
  async (data: { game_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const response: { data: { data: TRPSGameConfig }; status: number } =
        await gamesModel.postContinueAwaiting(data);
      dispatch(fetchGameState(data.game_id));
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
